<!-- 
	Header
	props: N/A
  role: Public
	Display logical header to public and users 
-->

<template>
  <header class="header bg-gray-900 text-white px-8 py-4 sm:px-40 text-center">
    <div class="flex items-center w-full">
      <router-link to="/">
        <img
          src="../assets/logo-winwin.svg"
          alt="logo"
          class="logo sm:hidden block"
        >
      </router-link>
      <div class="flex-1 text-right">
        <div
          v-if="user.loggedIn"
          :key="user"
        >
          <Menu
            as="div"
            class="relative inline-block text-left"
          >
            <div>
              <MenuButton class="link">
                <span class="text-sm sm:text-lg text-white"><i class="fas fa-cog" /></span>
              </MenuButton>
            </div>

            <transition
              enter-active-class="transition ease-out duration-100"
              enter-from-class="transform opacity-0 scale-95"
              enter-to-class="transform opacity-100 scale-100"
              leave-active-class="transition ease-in duration-75"
              leave-from-class="transform opacity-100 scale-100"
              leave-to-class="transform opacity-0 scale-95"
            >
              <MenuItems class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div class="py-1">
                  <MenuItem v-slot="{ active }">
                    <router-link
                      to="/settings/update-profile"
                      :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm']"
                    >
                      Update Profile
                    </router-link>
                  </MenuItem>
                  <MenuItem v-slot="{ active }">
                    <a
                      href="/settings/update-tickets"
                      :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm']"
                    >Update Ticket Selections</a>
                  </MenuItem>
                  <MenuItem v-slot="{ active }">
                    <a
                      href="/settings/opt-out"
                      :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm']"
                    >Opt-Out</a>
                  </MenuItem>
                  <MenuItem v-slot="{ active }">
                    <router-link
                      to="/change-password"
                      href="#"
                      :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm']"
                    >
                      Change Password
                    </router-link>
                  </MenuItem>
                  <MenuItem v-slot="{ active }">
                    <button
                      type="submit"
                      :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full text-left px-4 py-2 text-sm']"
                      @click.stop.prevent="signOut"
                    >
                      Sign out
                    </button>
                  </MenuItem>
                </div>
              </MenuItems>
            </transition>
          </Menu>				
          <span
            class="link text-sm sm:text-lg"
            @click.prevent="signOut"
          ><span class="hidden sm:inline">Sign Out</span>
            <i class="fas fa-sign-out-alt pl-2" /></span>
        </div>
        <div v-else>
          <span
            class="link text-sm sm:text-lg"
            @click="formReg()"
          >Register</span>
          <span
            class="link text-sm sm:text-lg"
            @click="formLogin()"
          >Login</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
	import firebase from "firebase";
	import { mapGetters } from "vuex";
	import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

	export default {
		name: "Header",
		components: {Menu, MenuButton, MenuItem, MenuItems},
		computed: {
			...mapGetters({
				user: "user",
			}),
		},
		methods: {
			formReg: function() {
				// hyperlink to registration component on Auth page
				this.register = true;
				this.$store.commit("formReg", this.register);
			},
			formLogin: function() {
				// hyperlink to login component on Auth page
				this.register = false;
				this.$store.commit("formLogin", this.register);
			},
			signOut() {
				firebase
					.auth()
					.signOut()
					.then(() => {
						// logout firebase user
						this.$store.dispatch("fetchUser", null);

						this.$router.replace({
							name: "Auth",
						});
					});
			},
		},
	};
</script>

<style>
	.header .logo {
		max-width: 100px;
		width: 100%;
	}

	.header .link {
		margin-left: 22px;
		cursor: pointer;
	}

	#headlessui-menu-items-2 {
	z-index: 1000;
}

</style>
